
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-7c8b0352\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./recommend-friend-history.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./recommend-friend-history.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7c8b0352\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./recommend-friend-history.vue"),
  /* scopeId */
  "data-v-7c8b0352",
  /* cssModules */
  null
)
Component.options.__file = "D:\\a\\1\\s\\CutomerAppRazorPrerender\\scripts\\src\\pages\\referral-program\\recommend-friend-history.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] recommend-friend-history.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c8b0352", Component.options)
  } else {
    hotAPI.reload("data-v-7c8b0352", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/src/pages/referral-program/recommend-friend-history.vue
// module id = 770
// module chunks = 0